import { AuthenticateResponse } from '../../api/auth';

export type UIState = {
  drawerState: DrawerState;
  token: AuthenticateResponse;
};

export enum DrawerState {
  Expanded,
  Collapsed,
  Closed,
}
